export const borderRadius = {
  X4: '4px',
  X8: '8px',
  X12: '12px',
} as const
